import { AppContext } from "@lightspeed-invoicing/core-client/frontend"
import { UpsertPayload } from "./types"

export class Service {
    static fetchListing () {
        return AppContext.getApiClient().get("/inventory-locations")
    }

    static get(locationId: string) {
        return AppContext.getApiClient().get(`/inventory-locations/${locationId}`)
    }

    static create(payload: UpsertPayload) {
        return AppContext.getApiClient().post("/inventory-locations", payload)
    }

    static patch(locationId: string, payload: UpsertPayload){
        return AppContext.getApiClient().patch(`/inventory-locations/${locationId}`, payload)
    }

    static delete(locationId: string){
        return AppContext.getApiClient().delete(`/inventory-locations/${locationId}`)
    }
}


// WEBPACK FOOTER //
// ./src/state/inventory/location/services/service.ts